var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDummySquareSmall = function SvgDummySquareSmall(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2002V12.8002C8 13.9203 8 14.4801 8.21799 14.9079C8.40973 15.2842 8.71547 15.5905 9.0918 15.7822C9.5192 16 10.079 16 11.1969 16H12.8031C13.921 16 14.48 16 14.9074 15.7822C15.2837 15.5905 15.5905 15.2842 15.7822 14.9079C16 14.4805 16 13.9215 16 12.8036V11.1969C16 10.079 16 9.5192 15.7822 9.0918C15.5905 8.71547 15.2837 8.40973 14.9074 8.21799C14.4796 8 13.9203 8 12.8002 8H11.2002C10.0801 8 9.51962 8 9.0918 8.21799C8.71547 8.40973 8.40973 8.71547 8.21799 9.0918C8 9.51962 8 10.0801 8 11.2002Z",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDummySquareSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dummy_Square_Small.570e13e7.svg";
export { ForwardRef as ReactComponent };